import React from "react";
import logo from "../../../assets/images/logo.png";
import { NavLink } from "react-router-dom";

const component=(props)=> {
return (
<nav className="navbar navbar-expand-lg navbar-dark bg-primary">
  <div className="container-fluid">
    <a className="navbar-brand" href="/">
        <img src={logo} alt="logo myZoo" width="50px" className="rounded"></img>
    </a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarColor01" aria-controls="navbarColor01" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>

    <div className="collapse navbar-collapse" id="navbarColor01">
      <ul className="navbar-nav me-auto">
        <li className="nav-item">
          {/* route exacte, bouton nav enfoncé */}      
          <NavLink to="/" exact="true" className="nav-link">Accueil</NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/animaux" exact="true" className="nav-link">Les animaux</NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/contact" exact="true" className="nav-link">Contact</NavLink>
        </li>
        
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Dropdown</a>
          <div className="dropdown-menu">
            <a className="dropdown-item" href="#">Action</a>
            <a className="dropdown-item" href="#">Another action</a>
            <a className="dropdown-item" href="#">Something else here</a>
            <div className="dropdown-divider"></div>
            <a className="dropdown-item" href="#">Separated link</a>
          </div>
        </li>
      </ul>
      <form className="d-flex">
        <input className="form-control me-sm-2" type="text" placeholder="Search"></input>
        <button className="btn btn-secondary my-2 my-sm-0" type="submit">Search</button>
      </form>
    </div>
  </div>
</nav>

)
}
export default component